import { Select, Tooltip } from "antd";
import { useState } from "react";
import { Trans } from "react-i18next";
import { SpecialCampaignApprovalEnum } from "shared/enums/SpecialCampaignApprovalEnum";
import "./DynamicStyledSelect.scss";

export interface DynamicStyledSelectProps {
  options: any[];
  initialValue: SpecialCampaignApprovalEnum;
  onChange: (newVal: SpecialCampaignApprovalEnum) => void;
  disabled?: boolean;
}

const DynamicStyledSelect: React.FC<DynamicStyledSelectProps> = ({
  initialValue,
  disabled,
  onChange,
  options,
}) => {
  const [value, setValue] = useState<SpecialCampaignApprovalEnum>(initialValue);

  return (
    <Tooltip
      title={
        disabled && (
          <Trans
            i18nKey="pages.LabelManagement.editBlocked"
            ns="radar"
            components={{ bold: <strong />, list: <ul />, item: <li /> }}
          />
        )
      }
    >
      <Select
        onChange={async (newValue) => {
          await onChange(newValue);
          setValue(newValue);
        }}
        className="dynamic-styled-select"
        showArrow={false}
        popupClassName="dynamic-styled-select-popup"
        dropdownMatchSelectWidth={false}
        dropdownRender={(menu) => (
          <div className="custom-dropdown">
            <div className="container">
              <div className="arrow" />
              {menu}
            </div>
          </div>
        )}
        disabled={disabled}
        dropdownAlign={{ offset: [-20, -4] }}
        options={options}
        value={value}
      />
    </Tooltip>
  );
};

export default DynamicStyledSelect;
